/**
 * Created by linjianxi on 2016/10/29.
 */
export const GET_HQPORD_LIVE_COUNT = ' GET_HQPORD_LIVE_COUNT '
export const GET_HQPORD_INDEX_LIST = ' GET_HQPORD_INDEX_LIST '
export const CHECK_OPEN_MONEY_STATUS = 'CHECK_OPEN_MONEY_STATUS'



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_index/mutation-type.js